import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./Sidebar";

const PageNotFound = () => {
    return(
        <>
        <Header/>
            <div className="main-page">
                <Sidebar/>
                <div className="nopage-wrap">
                <div className="line-1">404</div>
                <div className="line-2">Uh Oh! Page Not Found!</div>
                <div className="para-line">Sorry, the page you were looking for can not be found.</div>

                <div className="nopage-tip">
                    <Link to="/">Click here</Link> to Go to Home page.
                </div>
                </div>
            </div>
        <Footer/>
        </>
    );
}

export default PageNotFound;